export default __webpack_public_path__ + "static/113-3b675df45d16f4dd3cdab2c4d3326143.jpg";